import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable, tap } from 'rxjs';

import { BaseHttpService, type HttpResponseModel } from '../../../../core/services/base-http.service';
import { ResponseHandlerService } from '../../../../core/services/response-handler/response-handler.service';
import { type LoginData } from '../../models/login-response.model';
import { RbacService } from '../../../../core/utils/services/rbac/rbac.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseHttpService {


   constructor(
    protected override httpClient: HttpClient,
    private responseHandlerService: ResponseHandlerService,
    private rbacService: RbacService,
    private router: Router
  ) {
    super(httpClient);
   // Restore permissions on reload
   const storedUser = this.loadUserDataFromLocalStorage();
   if (storedUser?.permissions) {
     this.rbacService.setPermissions(storedUser.permissions);
   }
  }

  userSignIn(email: string, password: string): Observable<LoginData | null> {
    return this.httpClient.post<HttpResponseModel<LoginData>>(`${this.baseUrl}user/login`,
      { email, password })
      .pipe(
        map((response) => this.responseHandlerService.validateResponse<LoginData>(response)),
        tap((validatedData) => {
          if (validatedData) {
            this.saveUserDataToLocal({
              id: validatedData.id,
              name: validatedData.name,
              email: validatedData.email,
              token: validatedData.token, 
              permissions: validatedData.permissions, 
            });
            this.rbacService.setPermissions(validatedData.permissions); 
          }
        }),
      );
  }

  forgotPassword(email: string): Observable<any> {
    return this.httpClient.post<HttpResponseModel<any>>(`${this.baseUrl}user/resetpassword`, { email })
      .pipe(
        map((response) => this.responseHandlerService.validateResponse<any>(response)),
      );
  }

  logout(): void {
    this.clearLocalStorage();
    this.rbacService.setPermissions([]);
    this.redirectToSignIn();
  }

  get isAuthenticated(): boolean {

    const userData = this.loadUserDataFromLocalStorage();
    if (!userData?.token) return false;

    return !this.isTokenExpired(userData.token);
  //  return !!this.loadUserDataFromLocalStorage();
  }

  get userToken(): string | null {
    const userData = this.loadUserDataFromLocalStorage();
    return userData ? userData.token : null;
  }

  private isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp;
      return Date.now() >= exp * 1000;
    } catch {
      return true;
    }
  }

  private saveUserDataToLocal(userData: LoginData): void {
    localStorage.setItem('userData', JSON.stringify(userData));
  }

 

  // private loadUserDataFromLocalStorage(): LoginData | null {
  //   const userData = localStorage.getItem('userData');
  //   if (userData) {
  //     return JSON.parse(userData);
  //   }
  //   return null;
  // }

  private loadUserDataFromLocalStorage(): LoginData | null {
    const userData = localStorage.getItem('userData');
    if (userData) {
      return JSON.parse(userData);
    }
    return null;
  }
  
  // private loadUserDataFromLocalStorage() {
  //   // Check if localStorage is available (browser environment)
  //   if (typeof localStorage !== 'undefined') {
  //     const userData = localStorage.getItem('userData');
  //     return userData ? JSON.parse(userData) : null;
  //   }
  //   return null;
  // }

  private clearLocalStorage(): void {
    localStorage.removeItem('userData');
  }

  private redirectToSignIn(): void {
    this.router.navigate(['/login'], {
      replaceUrl: true
    });
  }
}
